(function () {
  var SECTION_SEL = '.oddit-section-sticky-atc';

  function init(bar) {
    if (!bar || bar._odditStickyAtcInit) return;
    bar._odditStickyAtcInit = true;

    var threshold = parseInt(bar.getAttribute('data-show-after-scroll'), 10);
    if (isNaN(threshold)) threshold = 500;

    var buyBox = document.querySelector('.oddit-section-main-product__buy-box');
    var footer = document.querySelector('.oddit-footer-main') || document.querySelector('footer');

    var pastTrigger = false;
    var atFooter = false;

    function apply() {
      var show = pastTrigger && !atFooter;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        pastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        apply();
      }, { threshold: 0 }).observe(buyBox);
    } else {
      var onScroll = function () {
        pastTrigger = window.scrollY > threshold;
        apply();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        atFooter = entries[0].isIntersecting;
        apply();
      }, { threshold: 0 }).observe(footer);
    }

    apply();
  }

  function boot() {
    init(document.querySelector(SECTION_SEL));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector(SECTION_SEL);
    if (bar) init(bar);
  });
})();
